import { render, staticRenderFns } from "./TopUpPage.vue?vue&type=template&id=329cfcbe&scoped=true&"
import script from "./TopUpPage.vue?vue&type=script&lang=js&"
export * from "./TopUpPage.vue?vue&type=script&lang=js&"
import style0 from "./TopUpPage.vue?vue&type=style&index=0&id=329cfcbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329cfcbe",
  null
  
)

export default component.exports